import { getThemedData } from '$utils'

import CaptainAppLogo from '$assets/captain_app_logo.svg'
import CarroAppLogo from '$assets/carro_app_logo.svg'
import GenieAppLogo from '$assets/genie_app_logo.svg'
import MottoAppLogo from '$assets/motto_app_logo.svg'
import { themeVars } from '@genie-fintech/ui/style/theme'

const { colors } = themeVars

export const COMPANY_NAME = getThemedData({
  motto: 'Motto SSO',
  carro: 'Carro SSO'
})

export const PASSWORD_LOGIN_URL_LABEL = getThemedData({
  motto: 'Motto SSO Login Link',
  carro: 'Carro SSO Login Link'
})

export const APP_BRANDS = getThemedData({
  carro: [
    {
      name: 'captain',
      Icon: CaptainAppLogo,
      backgroundColor: colors.alphaPrimary[1]
    },
    {
      name: 'carro',
      Icon: CarroAppLogo,
      backgroundColor: 'hsla(18,100%,50%,0.1)'
    },
    {
      name: 'genie',
      Icon: GenieAppLogo,
      backgroundColor: colors.alphaPrimary[1]
    }
  ],
  motto: [
    {
      name: 'motto',
      Icon: MottoAppLogo,
      backgroundColor: colors.alphaNeutral[1]
    }
  ]
})
